import Modal from "@via/components/modal.tsx";
import React, { type FC, useState } from "react";

type FileExtensionModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  suggestedExtension: string;
  onConfirm: (extension: string) => Promise<void>;
};

const FileExtensionModal: FC<FileExtensionModalProps> = ({
  open,
  setOpen,
  suggestedExtension,
  onConfirm,
}) => {
  const [inputValue, setInputValue] = useState("");
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleModalConfirm = async () => {
    await onConfirm(inputValue);
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Provide File Extension"
      isConfirmLoading={false}
      onConfirm={handleModalConfirm}>
      <div className="flex flex-col py-2 text-sm leading-6 text-slate-600 md:py-3 lg:py-4">
        <p>
          Foundry was unable to determine some file extensions. Please provide
          the file extension that will be used to process files. Be aware that
          this extension will be used for whole dataset
        </p>

        <div className="my-2">
          <span className="font-bold">Suggested Extension:</span>{" "}
          {suggestedExtension}
        </div>
        <div className="flex flex-col text-sm leading-6 text-slate-600 mb-2">
          <div className="mt-2">
            <input
              type="text"
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6"
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FileExtensionModal;
